
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo SEO optimisé */}
          <div className="flex items-center space-x-3">
            <div className="flex items-center">
              <span className="text-2xl font-bold text-orange-500">FMS</span>
              <div className="w-6 h-6 ml-2 flex items-center justify-center">
                <i className="ri-wifi-line text-blue-500 text-xl"></i>
              </div>
            </div>
            <div className="text-xs text-gray-700 leading-tight">
              <strong>Sécurité Belgique</strong><br />
              Charleroi • Bruxelles • Namur
            </div>
          </div>

          {/* Navigation Desktop avec mots-clés SEO */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('accueil')}
              className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer"
              title="Accueil FMS Protec Belgique"
            >
              Accueil
            </button>
            <button 
              onClick={() => scrollToSection('pourquoi-nous')}
              className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer"
              title="Pourquoi choisir notre entreprise sécurité Belgique"
            >
              Pourquoi nous ?
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer"
              title="Services sécurité : alarme maison, caméra surveillance Belgique"
            >
              Services Sécurité
            </button>
            <button 
              onClick={() => {
                window.REACT_APP_NAVIGATE('/blog');
              }}
              className="text-gray-700 hover:text-orange-500 transition-colors cursor-pointer"
              title="Blog sécurité Belgique - Conseils alarme et surveillance"
            >
              Blog Sécurité
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
              title="Contact devis gratuit sécurité Belgique"
            >
              Devis Gratuit
            </button>
          </nav>

          {/* Menu Mobile */}
          <button
            className="md:hidden p-2 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Menu navigation"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Menu Mobile Dropdown */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 py-4">
            <nav className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('accueil')}
                className="text-gray-700 hover:text-orange-500 transition-colors text-left cursor-pointer"
              >
                Accueil
              </button>
              <button 
                onClick={() => scrollToSection('pourquoi-nous')}
                className="text-gray-700 hover:text-orange-500 transition-colors text-left cursor-pointer"
              >
                Pourquoi nous ?
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-orange-500 transition-colors text-left cursor-pointer"
              >
                Services Sécurité
              </button>
              <button 
                onClick={() => {
                  window.REACT_APP_NAVIGATE('/blog');
                  setIsMenuOpen(false);
                }}
                className="text-gray-700 hover:text-orange-500 transition-colors text-left cursor-pointer"
              >
                Blog Sécurité
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg transition-all duration-200 text-left cursor-pointer whitespace-nowrap w-fit"
              >
                Devis Gratuit
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
